import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoadingProps {
  tip?: string;
  size?: 'small' | 'default' | 'large';
  fullScreen?: boolean;
}

export default function Loading({ tip = 'Loading...', size = 'large', fullScreen = false }: LoadingProps) {
  const antIcon = <LoadingOutlined style={{ fontSize: size === 'large' ? 48 : size === 'default' ? 32 : 24 }} spin />;

  if (fullScreen) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 16,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
        }}
      >
        <Spin indicator={antIcon} size={size} spinning />
        {tip && <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{tip}</div>}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <Spin indicator={antIcon} size={size} spinning />
      {tip && <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{tip}</div>}
    </div>
  );
}
